/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import SwiperCore, { Pagination, Mousewheel } from 'swiper/core';
import Image from '../utils/image';

SwiperCore.use([Pagination]);

const pagination = {
  el: '.custom-pagination',
  clickable: true,
  type: 'progressbar',
};

const ProductGalleryZoom = ({ currentProduct, initZoom, setInitZoom }) => {
  const zoomGallery = useRef(null);
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);
  const lastFocusedElement = useRef(null);

  useEffect(() => {
    if (initZoom) {
      lastFocusedElement.current = document.activeElement;

      if (zoomGallery?.current?.swiper?.slides?.length > 0) {
        zoomGallery.current.swiper.slides[0].focus();
      }

      // Trap focus inside modal
      const focusableElements = modalRef.current?.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );

      if (focusableElements.length) {
        focusableElements[0].focus();
      }

      const handleTabKey = (e) => {
        if (e.key !== 'Tab') return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey && document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      };

      document.addEventListener('keydown', handleTabKey);

      return () => {
        document.removeEventListener('keydown', handleTabKey);
      };
    }
  }, [initZoom]);

  // Restore focus when gallery closes
  const closeGallery = () => {
    setInitZoom(false);
    setTimeout(() => {
      if (lastFocusedElement.current) {
        lastFocusedElement.current.focus();
      }
    }, 100);
  };

  if (initZoom) {
    return (
      <div
        class="fixed top-0 left-0 w-full h-screen z-50 overflow-y-scroll bg-primary-2"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
      >
        <div className="max-w-full max-h-screen">
          <Swiper
            modules={[Pagination, Mousewheel]}
            slidesPerView={2}
            pagination={pagination}
            spaceBetween={5}
            mousewheel={true}
            ref={zoomGallery}
          >
            {currentProduct?.images?.edges?.map((img, index) => {
              if (index !== 0) {
                return (
                  <SwiperSlide key={index} tabIndex={0}>
                    <Image
                      {...img.node}
                      className="max-h-screen w-auto mx-auto"
                      srcWidths={{
                        sm: 640,
                        md: 768,
                        lg: 509,
                        xl: 680,
                        '2xl': 680,
                      }}
                    />
                  </SwiperSlide>
                );
              }
            })}
          </Swiper>
          <div className="custom-pagination !fixed !bottom-10 !top-auto !left-[5%] !w-[90%] !z-10 !bg-grey-400" />
        </div>
        <button
          ref={closeButtonRef}
          className="fixed top-10 right-10 rounded-[50%] bg-primary-2 p-3.5 cursor-pointer z-10"
          onClick={closeGallery}
        >
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.33301 17.3666L16.6663 3.47332"
              stroke="#FF5200"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M3.33301 3.47333L16.6663 17.3666"
              stroke="#FF5200"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    );
  }

  return null;
};

export default ProductGalleryZoom;
